// Game Constants Module
// Central location for all game configuration values

// Canvas dimensions
export const CANVAS_W = 800;
export const CANVAS_H = 560;
export const MIN_DIST = 40;
export const PIECE_R = 22;

// Atmospheric Zone Thresholds (drive environmental feedback)
export const ZONE_UNCERTAIN = { min: 0, max: 50 };      // Drifting, searching
export const ZONE_POROUS = { min: 60, max: 85 };        // "This is working"
export const ZONE_NERVOUS = { min: 85, max: 100 };      // Something is wrong...

// Timing Constants
export const EQUILIBRIUM_THRESHOLD_MS = 75000;  // 75 seconds in porous zone = winning
export const UNKNOWN_CREEP_START_MS = 30000;    // Unknown starts creeping 30s after first piece
export const UNKNOWN_CREEP_RATE = 0.35;         // % per 1000ms tick
export const IDLE_CREEP_DIVISOR = 80;           // Lower = faster idle creep
export const IDLE_PRESSURE_START_MS = 5000;     // 5 seconds idle before pressure

// Void Block Constants
export const VOID_FORCE_RADIUS = Math.min(CANVAS_W, CANVAS_H) * 0.125; // 25% diameter = 12.5% radius
export const VOID_PENALTY = 4;                  // Permanent penalty added to unknown pressure
export const LINE_ERASE_RADIUS = 15;            // Distance threshold for erasing lines

// Drawing Constants
export const SUPER_SLOW_THRESHOLD = 40;         // px/s - below this is "super slow" drawing

// Special Shapes (won from equilibrium lottery)
export const SPECIAL_SHAPES = ['cross', 'arrow', 'crescent', 'bolt', 'wave', 'heart', 'cloud', 'spiral', 'fragment', 'eye'];
